import React from "react";

// Branded loading state: the TPE mark centered with a soft "breathing" pulse
// and a slim indeterminate bar, shown while the app data or a lazy route chunk
// loads — replaces the bare top-left "Loading…" text so the wait reads as the
// organization, not a stalled page. Self-contained (inline styles + keyframes),
// no dependency. Sits in the area below the 75px navbar by default; pass
// fullScreen to cover everything (e.g. pre-auth boot).
const LOGO = `${process.env.PUBLIC_URL || ""}/images/headerlogo.png`;

export default function BrandLoader({ fullScreen = false, label = "Loading" }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label}
      style={{
        position: fullScreen ? "fixed" : "relative",
        inset: fullScreen ? 0 : undefined,
        zIndex: fullScreen ? 4000 : undefined,
        width: "100%",
        minHeight: fullScreen ? "100dvh" : "calc(100dvh - 75px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 24,
        background: "linear-gradient(180deg,#f7fbfe 0%,#eef4f8 100%)",
      }}
    >
      <style>{`
        @keyframes tpe-breathe {
          0%,100% { transform: scale(1);     opacity: .9; }
          50%     { transform: scale(1.045); opacity: 1;  }
        }
        @keyframes tpe-bar {
          0%   { transform: translateX(-120%); }
          100% { transform: translateX(320%);  }
        }
      `}</style>

      <img
        src={LOGO}
        alt="The Perfect Event"
        style={{
          width: 240,
          maxWidth: "62vw",
          height: "auto",
          animation: "tpe-breathe 2s ease-in-out infinite",
        }}
      />

      {/* Indeterminate progress sliver in the brand blue. */}
      <div
        style={{
          position: "relative",
          width: 190,
          height: 3,
          borderRadius: 999,
          background: "rgba(41,163,216,0.16)",
          overflow: "hidden",
        }}
      >
        <span
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "45%",
            borderRadius: 999,
            background: "#29a3d8",
            animation: "tpe-bar 1.2s ease-in-out infinite",
          }}
        />
      </div>
    </div>
  );
}
